import { model as router } from '!/router'
import { api } from '@setplex/tria-api'
import { createEvent, sample } from 'effector'

// *
// * EVENTS
// *

export const initExactTvChannelPage = createEvent<{ channelId: number }>()

export const getTvChannelUrl = createEvent<{ channelId: number }>()

export const postTvRecord = createEvent<{
  channelId: number
  start: number
  stop: number
}>()

export const seeAllTvClick = createEvent<{ id: number }>()
sample({
  clock: seeAllTvClick,
  fn: ({ id }) => `/content/live/categories/${id}`,
  target: router.navigatePush,
})

// *
// * CONNECTIONS
// *

// /content/live/:id
sample({
  clock: initExactTvChannelPage,
  target: [getTvChannelUrl],
})

sample({
  clock: initExactTvChannelPage,
  target: [api.tv.getTvChannelUrlFx],
})
